<div class="checkin__booking__card">
  <span class="checkin__sidebar__item__subtitle">{{ 'linked-card' | translate }}:</span>
  <span class="checkin__booking__card__number">{{ creditCardNumber }}</span>
  <app-button-primary
    (buttonClick)="goToCard()"
    [text]="ctaText">
  </app-button-primary>
</div>
